import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, Mail, Book, Shield, Users, Code } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Logo i opis */}
          <div className="col-span-1 md:col-span-3">
            <div className="flex items-center gap-2 mb-4">
              <Brain className="h-8 w-8 text-purple-500" />
              <span className="text-xl font-bold text-white">Kariera z AI</span>
            </div>
            <p className="text-gray-400 mb-4">
              Pomagamy odkryć i rozwinąć karierę w zawodach przyszłości w minuty.
              Wykorzystujemy sztuczną inteligencję do personalizacji ścieżki rozwoju.
            </p>
          </div>

          {/* Linki */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-white font-semibold mb-4">Ważne linki</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog/ai-w-planowaniu-kariery" className="hover:text-purple-400 transition-colors">
                  AI w karierze
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-purple-400 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/dokumentacja" className="hover:text-purple-400 transition-colors">
                  Dokumentacja
                </Link>
              </li>
              <li>
                <Link to="/polityka-prywatnosci" className="hover:text-purple-400 transition-colors">
                  Polityka prywatności
                </Link>
              </li>
              <li>
                <Link to="/regulamin" className="hover:text-purple-400 transition-colors">
                  Regulamin
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-purple-400 transition-colors">
                  Polityka cookies
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-1 md:col-span-5">
            <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
              <Book className="w-5 h-5" />
              Dokumentacja platformy
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="text-purple-400 font-medium mb-2 flex items-center gap-2">
                  <Shield className="w-4 h-4" />
                  Bezpieczeństwo i prywatność
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>Szyfrowanie danych SSL/TLS</li>
                  <li>Zgodność z RODO/GDPR</li>
                  <li>Bezpieczne płatności Stripe</li>
                  <li>Ochrona danych osobowych</li>
                </ul>
              </div>
              <div>
                <h4 className="text-purple-400 font-medium mb-2 flex items-center gap-2">
                  <Users className="w-4 h-4" />
                  Funkcjonalności
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>Analiza predyspozycji AI</li>
                  <li>Spersonalizowane rekomendacje</li>
                  <li>Plan rozwoju kariery</li>
                  <li>Dopasowane oferty pracy</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Kontakt */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:polokontaktowy@gmail.com" className="hover:text-purple-400 transition-colors">
                  polokontaktowy@gmail.com
                </a>
              </li>
            </ul>
          </div>
          
          {/* SEO Footer */}
          <div className="col-span-1 md:col-span-4 mt-8 pt-8 border-t border-gray-800">
            <p className="text-sm text-gray-400 leading-relaxed">
              Kariera z AI to innowacyjna platforma wykorzystująca sztuczną inteligencję do personalizowanego doradztwa kariery.
              Oferujemy zaawansowaną analizę predyspozycji zawodowych, rekomendacje ścieżek kariery i spersonalizowany plan rozwoju.
              Nasza platforma łączy najnowsze technologie AI z ekspertyzą w doradztwie zawodowym, pomagając użytkownikom w podejmowaniu
              świadomych decyzji dotyczących ich przyszłości zawodowej. Działamy w całej Polsce, wspierając zarówno osoby rozpoczynające
              karierę, jak i profesjonalistów szukających nowych możliwości rozwoju.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm">
          <p>© {currentYear} Kariera z AI. Wszystkie prawa zastrzeżone.</p>
        </div>
      </div>
    </footer>
  );
}
